<template>
    <div class="public-offer-empty">
        <default-title :size="16" :line-height="21">
            {{ t("payments.public-offer.expired") }}
        </default-title>
    </div>
</template>

<script>
import DefaultTitle from "@components/Typography/DefaultTitle"

export default {
    name: "PublicOfferEmpty",
    components: { DefaultTitle }
}
</script>

<style scoped lang="sass">
.public-offer-empty
    padding: 20px
    margin-top: 20px
    box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15)
    border-radius: 10px
</style>
